import {RootState} from "../store";

export const authSelector = (state: RootState) => state.auth?.isAuth;
export const userSelector = (state: RootState) => state.auth?.user;
export const pendingSelector = (state: RootState) => state.auth?.isPending;
export const userStateSelector = (state: RootState) => state.auth;
export const resetSelector = (state: RootState) => state.auth.reset;
export const errorSelector = (state: RootState) => state.auth.error;

